import { useQuery } from '@tanstack/react-query';
import { rolesService, UsersQueryParams } from '@/services';

export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (params: UsersQueryParams) => [...roleKeys.lists(), params] as const,
  details: () => [...roleKeys.all, 'detail'] as const,
  detail: (id: string) => [...roleKeys.details(), id] as const,
};


export const useRolesForDropdown = () => {
  return useQuery({
    queryKey: ['roles', 'all'],
    queryFn: () => rolesService.getRoles({ _size: 1000 }),
    staleTime: 10 * 60 * 1000,
    select: (data) => data.content,
  });
};

